import { FuelGridItem, FuelCheckbox, FuelButton, FuelTypography } from '@frete.com/fuel-react'
import { ModalAside } from '~components'
import { Props } from './interfaces'
import * as Styled from './styled'
import { Text } from '~constants/text'
import { Users } from '~services'
import { useRequest } from 'ahooks'
import { useTranslator } from '~hooks'

function FilterUserModal({ open, values, handleClose, handleChange, handleSubmit, handleCancel }: Props) {
  const { translate } = useTranslator()

  const isProd = process.env.ENVIRONMENT === 'prod'
  const FLAG = isProd ? 76 : 95

  const { data: dataFeaturedFlag } = useRequest(() => Users.getFeaturedFlag(FLAG))
  const canShowSimpleCollaborator = dataFeaturedFlag?.access === true

  return (
    <>
      <ModalAside
        open={open}
        title="Filtros"
        portalName="filter-user"
        onClose={() => {
          handleClose?.()
        }}
      >
        <Styled.GridContainer>
          <FuelGridItem>
            <Styled.GridContainer>
              <FuelGridItem sm={4}>
                <FuelTypography tag="p" size="heading-sm" weight="bold">
                  {translate(Text.ACCESS_LEVEL, { obligation: '' })}
                </FuelTypography>
              </FuelGridItem>
              <FuelGridItem sm={4}>
                <Styled.Radio
                  data-testid="permission_id_adm"
                  label={translate(Text.ADMINISTRATOR)}
                  value="1"
                  name="permissionId"
                  onInput={handleChange}
                  checked={values.permissionId === '1'}
                />
                <Styled.Radio
                  data-testid="permission_id_colaborator"
                  label={translate(Text.COLABORATOR)}
                  value="2"
                  name="permissionId"
                  onInput={handleChange}
                  checked={values.permissionId === '2'}
                />
                {canShowSimpleCollaborator && (
                  <Styled.Radio
                    data-testid="permission_id_simple_colaborator"
                    label={translate(Text.SIMPLE_COLABORATOR)}
                    value="3"
                    name="permissionId"
                    onInput={handleChange}
                    checked={values.permissionId === '3'}
                  />
                )}
              </FuelGridItem>
            </Styled.GridContainer>
          </FuelGridItem>

          <FuelGridItem>
            <Styled.GridContainer>
              <FuelGridItem sm={4}>
                <FuelTypography tag="p" size="heading-sm" weight="bold">
                  {translate(Text.CONTACT)}
                </FuelTypography>
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <Styled.Checkbox
                  label={translate(Text.ONLY_CALL)}
                  value="0"
                  name="typeNumber"
                  onInput={handleChange}
                  data-testid="typeNumber_only_call"
                  checked={values.typeNumber.includes('0')}
                />
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <Styled.Checkbox
                  label={translate(Text.CALL_AND_WHATSAPP)}
                  value="2"
                  name="typeNumber"
                  onInput={handleChange}
                  data-testid="typeNumber_call_and_whatsapp"
                  checked={values.typeNumber.includes('2')}
                />
              </FuelGridItem>
            </Styled.GridContainer>
          </FuelGridItem>

          <FuelGridItem>
            <Styled.GridContainer>
              <FuelGridItem sm={4}>
                <FuelTypography tag="p" size="heading-sm" weight="bold">
                  {translate(Text.DEPARTAMENT)}
                </FuelTypography>
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <FuelCheckbox
                  label={translate(Text.ADMINISTRATIVE)}
                  value="1"
                  checked={values.sectorId.includes('1')}
                  name="sectorId"
                  data-testid="sector_id_administrative"
                  onInput={handleChange}
                />
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <FuelCheckbox
                  label={translate(Text.OPERACIONAL)}
                  value="8"
                  checked={values.sectorId.includes('8')}
                  name="sectorId"
                  data-testid="sector_id_operacional"
                  onInput={handleChange}
                />
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <FuelCheckbox
                  label={translate(Text.COMMERCIAL)}
                  value="2"
                  checked={values.sectorId.includes('2')}
                  name="sectorId"
                  data-testid="sector_id_comercial"
                  onInput={handleChange}
                />
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <FuelCheckbox
                  label={translate(Text.MANAGERIAL)}
                  value="7"
                  checked={values.sectorId.includes('7')}
                  name="sectorId"
                  data-testid="sector_id_managerial"
                  onInput={handleChange}
                />
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <FuelCheckbox
                  label={translate(Text.PURCHASES)}
                  value="3"
                  checked={values.sectorId.includes('3')}
                  name="sectorId"
                  data-testid="sector_id_purchases"
                  onInput={handleChange}
                />
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <FuelCheckbox
                  label={translate(Text.FINANCIAL)}
                  value="5"
                  checked={values.sectorId.includes('5')}
                  name="sectorId"
                  data-testid="sector_id_financial"
                  onInput={handleChange}
                />
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <FuelCheckbox
                  label={translate(Text.DIRECTORSHIP)}
                  value="4"
                  checked={values.sectorId.includes('4')}
                  name="sectorId"
                  data-testid="sector_id_directorship"
                  onInput={handleChange}
                />
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <FuelCheckbox
                  label={translate(Text.FISCAL)}
                  value="6"
                  checked={values.sectorId.includes('6')}
                  name="sectorId"
                  data-testid="sector_id_fiscal"
                  onInput={handleChange}
                />
              </FuelGridItem>
              <FuelGridItem sm={4} md={4}>
                <FuelCheckbox
                  label={translate(Text.SUPPORT)}
                  value="9"
                  checked={values.sectorId.includes('9')}
                  name="sectorId"
                  data-testid="sector_id_support"
                  onInput={handleChange}
                />
              </FuelGridItem>
            </Styled.GridContainer>
          </FuelGridItem>
        </Styled.GridContainer>
        <Styled.FilterButtons>
          <Styled.CleanButton variant="tertiary" type="submit" onClick={handleCancel} data-testid="cancel_modal_filter">
            {translate(Text.CLEAR_FILTER, { multiple: 's' })}
          </Styled.CleanButton>
          <FuelButton
            data-testid="apply_modal_filter"
            type="submit"
            variant="primary"
            onClick={() => {
              handleSubmit(values)
              handleClose()
            }}
          >
            {translate(Text.APPLY_FILTER, { multiple: 's' })}
          </FuelButton>
        </Styled.FilterButtons>
      </ModalAside>
    </>
  )
}

export default FilterUserModal
